import { render, staticRenderFns } from "./DatepickerSize.vue?vue&type=template&id=54cba8ca"
import script from "./DatepickerSize.vue?vue&type=script&lang=js"
export * from "./DatepickerSize.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports